











import { BFormFile } from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { 
    BFormFile
  },
  name: "multiple-file-input",
})
export default class MultipleFileInput extends Vue {
  @Prop({ required: true }) value: any
  @Prop({ required: false, default: false }) disabled: any

    onFileChange(event: any) {
    const files = event.target.files || event.dataTransfer?.files || event;
    
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      this.value?.push(...fileArray);
    }

    if (event.target) {
      event.target.value = '';
    }
  }
}

